import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Product } from '../product.decorator';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { IProductDataV2 } from '@df/catalog/product/product';

/**
 * Displays product price
 */
@Component({
    imports: [PriceComponent, TranslationModule],
    selector: 'product-price',
    templateUrl: './product-price.html',
    styleUrl: './product-price.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductPriceComponent {
    /**
     * Default image
     */
    @Input()
    product?: Product<IProductDataV2>;
}
